import { Menu, MenuWithChildren } from '../../../types/menu';

/**
 * Replace "first_level_menus" and "second_level_menus" key with "children"
 *
 * Input: {
 *  'Header': [
 *    {
 *      // ...menuData,
 *      first_level_menus: [
 *        {
 *          // ...menuData
 *        }
 *      ]
 *    }
 *  ]
 * }
 *
 * Output: {
 *  'Header': [
 *    {
 *      // ...menuData,
 *      children: [
 *        {
 *          // ...menuData
 *        }
 *      ]
 *    }
 *  ]
 * }
 */
export const transformMenusWithChildren = (menus: Menu[]): MenuWithChildren[] => {
  return menus.map((menu) => {
    return {
      ...menu,
      children: menu.first_level_menus.map((firstLevelMenu) => ({
        ...firstLevelMenu,
        children: firstLevelMenu.second_level_menus,
      })),
    };
  });
};
